import { render } from "./maintenance.vue?vue&type=template&id=187466a4&ts=true"
import script from "./maintenance.ts?vue&type=script&lang=ts"
export * from "./maintenance.ts?vue&type=script&lang=ts"

import "./maintenance.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__